export const enumToArray = <TValue>(
    e: { [key: string]: TValue },
    returnValue: "keys" | "values" = "values"
): TValue[] | string[] => (returnValue === "values" ? Object.values(e) : Object.keys(e));
